(() => {
  const READY_FLAG = "__pgCustomInit";
  const CART_COMPETITION_SECTION_KEY = "custom_liquid_EFh8qb";
  const IDLE_FALLBACK_MS = 1;
  let cartCompetitionSyncInFlight = false;

  const runWhenIdle = (callback, timeout = 1500) => {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(callback, { timeout });
      return;
    }
    window.setTimeout(() => callback({ didTimeout: true, timeRemaining: () => 0 }), IDLE_FALLBACK_MS);
  };

  function setScrollState() {
    document.body.classList.toggle("pg-scrolled", window.scrollY > 12);
  }

  function mountBackToTop() {
    if (document.getElementById("pg-back-to-top")) return;

    const button = document.createElement("button");
    button.type = "button";
    button.id = "pg-back-to-top";
    button.setAttribute("aria-label", "Vissza a tetejere");
    button.textContent = "^";

    const toggle = () => {
      button.classList.toggle("is-visible", window.scrollY > 560);
    };

    button.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });

    window.addEventListener("scroll", toggle, { passive: true });
    toggle();

    document.body.appendChild(button);
  }

  function mountProductAccordionStack(root = document) {
    if (!root.querySelector("product-info .product__info-container")) return;

    const containers = root.querySelectorAll("product-info .product__info-container");
    containers.forEach((container) => {
      if (container.querySelector(":scope > .pg-product-accordion-stack")) return;

      const accordionNodes = Array.from(
        container.querySelectorAll(
          ":scope > .product__accordion.accordion, :scope > .accordion:not(.product__accordion), :scope > .pg-brand-about"
        )
      );

      if (accordionNodes.length < 2) return;

      const stack = document.createElement("div");
      stack.className = "pg-product-accordion-stack";
      container.insertBefore(stack, accordionNodes[0]);

      accordionNodes.forEach((node) => {
        stack.appendChild(node);
      });
    });
  }

  function getCartTemplatePrefix(root = document) {
    const cartItemsSection = root.querySelector('[id^="shopify-section-template--"][id$="__cart-items"]');
    const sectionId = cartItemsSection?.id || "";
    const match = sectionId.match(/^shopify-section-(template--.+__)cart-items$/);
    return match ? match[1] : null;
  }

  async function syncCartCompetitionSection() {
    if (cartCompetitionSyncInFlight || typeof routes === "undefined" || window.location.pathname !== routes.cart_url) {
      return;
    }

    const currentSection = document.querySelector(`[id*="${CART_COMPETITION_SECTION_KEY}"]`);
    if (!currentSection) return;

    const templatePrefix = getCartTemplatePrefix();
    if (!templatePrefix) return;

    cartCompetitionSyncInFlight = true;

    try {
      const response = await fetch(
        `${routes.cart_url}?section_id=${encodeURIComponent(`${templatePrefix}${CART_COMPETITION_SECTION_KEY}`)}`,
        {
          credentials: "same-origin",
          headers: { "X-Requested-With": "XMLHttpRequest" },
        }
      );

      if (!response.ok) return;

      const sectionMarkup = (await response.text()).trim();
      if (!sectionMarkup.includes("pp-competition-wrap")) {
        currentSection.remove();
      }
    } catch (error) {
      console.error(error);
    } finally {
      cartCompetitionSyncInFlight = false;
    }
  }

  function init() {
    if (window[READY_FLAG]) return;
    window[READY_FLAG] = true;

    setScrollState();
    window.addEventListener("scroll", setScrollState, { passive: true });

    runWhenIdle(() => {
      mountBackToTop();
      mountProductAccordionStack();
      syncCartCompetitionSection();
    });

    document.addEventListener("shopify:section:load", (event) => {
      const root = event.target || document;
      runWhenIdle(() => {
        mountProductAccordionStack(root);
        syncCartCompetitionSection();
      });
    });

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        runWhenIdle(() => {
          syncCartCompetitionSection();
        });
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
